import { useCallback, useEffect } from 'react';
import { useAppDispatch, useAppSelector, usePrevious } from '../index';
import { forgotPassword } from '@ogsnetwork/opp-redux-lib';
import { combineValidationErrors, useStateWithValidation } from '../validation';
import { validateEmail } from './validation';
export function useForgotPassword(props) {
    const authentication = useAppSelector((state) => state.authentication);
    const dispatch = useAppDispatch();
    const previousStatus = usePrevious(authentication.status);
    const email = useStateWithValidation(validateEmail, '');
    const dispatchForgotPassword = useCallback(() => {
        dispatch(forgotPassword(email.value));
    }, [email.value]);
    useEffect(() => {
        var _a, _b;
        if (authentication.status === 'success' && previousStatus === 'submitting') {
            (_a = props === null || props === void 0 ? void 0 : props.onSuccess) === null || _a === void 0 ? void 0 : _a.call(props);
        }
        if (authentication.status === 'error' && previousStatus === 'submitting') {
            (_b = props === null || props === void 0 ? void 0 : props.onError) === null || _b === void 0 ? void 0 : _b.call(props);
        }
    }, [authentication.status]);
    const isValid = email.isValid && !email.isPristine;
    const validationErrors = combineValidationErrors(email.errors);
    return {
        email: email.value,
        setEmail: email.setValue,
        disableSubmit: !isValid,
        error: validationErrors !== null && validationErrors !== void 0 ? validationErrors : authentication.error,
        dispatchForgotPassword
    };
}
